
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.15 8.474l6.631 6.63a.714.714 0 010 1.03l-1.68 1.679a.727.727 0 01-1.03 0L8.42 11.161a4.749 4.749 0 01-5.031-1.08 4.736 4.736 0 01-.475-6.15L5.711 6.73l1.037-1.03-2.804-2.811a4.746 4.746 0 016.155.474 4.75 4.75 0 011.052 5.112zm-2.467.89l6.907 6.908.643-.65-6.9-6.9c.335-.431.554-.913.642-1.432A3.263 3.263 0 009.07 4.4a3.292 3.292 0 00-2.512-.957l2.256 2.256-3.096 3.097-2.256-2.257c-.051.906.27 1.826.964 2.512a3.266 3.266 0 002.796.913 3.193 3.193 0 001.46-.599z","fill":"#585858"}})])
          )
        }
      }
    